import * as React from 'react';
import { AuditForm, AuditModal } from '../../../auditmodal/components/AuditModal';
import { CoughSession } from 'webportalclient';
import { CoughSessionStatusEnum } from '../../../misc/api/apiTypes';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';

interface UnassignDeviceModalProps {
    record: CoughSession;
    onClose: () => void;
    onCompleted: () => void;
}

export const UnassignDeviceModal = (props: UnassignDeviceModalProps) => {
    const client = useWebPortalApiClient();
    const [submitting, setSubmitting] = React.useState(false);

    const onSubmit = async (auditForm: AuditForm) => {
        setSubmitting(true);
        const patchResult = await client.client.patchCoughSession({
            status: CoughSessionStatusEnum.DeviceUnassigned,
        }, props.record.id, auditForm.Annotation);

        if (patchResult) {
            props.onCompleted();
        }
        setSubmitting(false);
    }

    return (
        <AuditModal header="Unassign Device"
            isSubmitting={submitting}
            onClose={() => props.onClose()}
            onSubmit={(annotation) => onSubmit(annotation)}
        />
    );
}
